import React from 'react';
import { useSelector } from 'react-redux';

import { getFieldsForWorkPlanCreation } from './selectors';
import { getExportParams } from 'export-selector/selectors';
import { getMessage } from 'util/locale';

import WorkPlansFieldsSelectorRow from 'affiliates/WorkPlansFieldsSelectorRow';

const WorkPlansFieldsSelector = () => {
  const fields = useSelector(getFieldsForWorkPlanCreation);
  const { scripts } = useSelector(getExportParams);

  const fieldsRows = fields.map(({ area, farm, farmId, uuid, name }) => (
    <WorkPlansFieldsSelectorRow
      area={area}
      farm={farm}
      farmId={farmId}
      fieldsAmount={fields.length}
      uuid={uuid}
      key={uuid}
      name={name}
    />
  ));

  return (
    <table className="work-plans-fields-selector">
      <thead>
        <tr>
          <th role="columnheader">
            <p>{getMessage('fieldview')}</p>
            <small>{getMessage('generate-jd-work-plan-fv')}</small>
          </th>
          <th role="columnheader">
            <p>{getMessage('john-deere-clients')}</p>
            <small>{getMessage('john-deere-client-selection')}</small>
          </th>
          <th role="columnheader">
            <p>{getMessage('john-deere-fields')}</p>
            <small>
              {getMessage('generate-jd-work-plan-jd', {
                scriptCount: scripts || 1,
              })}
            </small>
          </th>
          {fields.length > 1 && <th>{getMessage('label-text__include')}</th>}
        </tr>
      </thead>
      <tbody>{fieldsRows}</tbody>
    </table>
  );
};

export default WorkPlansFieldsSelector;
